/* SKIN° Theme JS — vanilla, no dependencies */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Hoehe der Ankuendigungsleiste fuer den Hero (passt in den ersten Bildschirm) */
  const setAnn = () => { const a = document.querySelector('.announcement'); document.documentElement.style.setProperty('--ann-h', (a ? a.offsetHeight : 0) + 'px'); };
  setAnn(); window.addEventListener('resize', setAnn, { passive: true });
  const money = (cents) => {
    const fmt = window.SKIN && window.SKIN.moneyFormat ? window.SKIN.moneyFormat : '{{amount_with_comma_separator}} €';
    const v = (cents / 100).toFixed(2);
    const comma = v.replace('.', ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Drawers ---------- */
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const focusable = d.querySelector('button, a, input');
    focusable && focusable.focus();
  };
  const closeDrawers = () => {
    $$('.drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('drawer__backdrop')) closeDrawers();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Motion engine ---------- */
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealTargets = $$('[data-reveal], [data-reveal-fade], [data-stagger], .kenburns');
  if (!reduced && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    revealTargets.forEach((el) => io.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('is-visible'));
  }

  /* Load sequence for intro blocks outside the hero (journal, article, page intro) */
  $$('.hero__seq').forEach((seq) => {
    if (seq.closest('.hero')) return;
    const go = () => seq.classList.add('is-loaded');
    if (document.readyState === 'complete') requestAnimationFrame(go); else window.addEventListener('load', () => requestAnimationFrame(go), { once: true });
    setTimeout(go, 1200);
  });

  /* Hero load sequence + lazy video */
  $$('.hero').forEach((hero) => {
    const start = () => hero.classList.add('is-loaded');
    if (document.readyState === 'complete') requestAnimationFrame(start); else window.addEventListener('load', () => requestAnimationFrame(start), { once: true });
    const wrap = $('.hero__video', hero);
    const video = wrap && $('video', wrap);
    if (video && !reduced) {
      const mobile = window.matchMedia('(max-width: 900px)').matches;
      const src = (mobile && video.dataset.srcMobile) ? video.dataset.srcMobile : video.dataset.src;
      if (src) { video.src = src; }
      video.addEventListener('canplay', () => wrap.classList.add('is-ready'), { once: true });
      video.play && video.play().catch(() => {});
    }
  });

  /* Parallax (gentle, rAF, desktop only) */
  const plx = $$('[data-parallax]');
  if (plx.length && !reduced && window.innerWidth > 900) {
    let ticking = false;
    const run = () => {
      const vh = window.innerHeight;
      plx.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
        const amp = parseFloat(el.dataset.parallax) || 30;
        el.style.transform = `translate3d(0, ${(-p * amp).toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(run); ticking = true; } }, { passive: true });
    run();
  }

  /* Ritual: pinned media swaps with active step */
  $$('[data-ritual]').forEach((r) => {
    const steps = $$('.ritual__step', r);
    const imgs = $$('.ritual__media img', r);
    if (!steps.length) return;
    const activate = (i) => {
      steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      imgs.forEach((im, k) => im.classList.toggle('is-active', k === i || (imgs.length === 1 && k === 0)));
    };
    activate(0);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) activate(steps.indexOf(en.target)); });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach((s) => io.observe(s));
    }
  });

  /* Showcase video lazy load */
  $$('.showcase video[data-src]').forEach((v) => {
    if (reduced) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { v.src = v.dataset.src; v.play && v.play().catch(() => {}); io.disconnect(); } });
    }, { rootMargin: '200px' });
    io.observe(v);
  });

  /* Sticky mobile buy bar: shows once the buy box scrolls out */
  const buybar = $('.buybar');
  const buyBox = $('.product__buy');
  if (buybar && buyBox && 'IntersectionObserver' in window) {
    document.body.classList.add('has-buybar');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => buybar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
    }, { threshold: 0 });
    io.observe(buyBox);
    buybar.addEventListener('click', (e) => {
      if (e.target.closest('[data-buybar-add]')) { e.preventDefault(); const f = $('form.product-form'); f && f.requestSubmit(); }
    });
  }

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const main = $('[data-gallery-main]', g);
    $$('[data-gallery-thumb]', g).forEach((t) => {
      t.addEventListener('click', () => {
        $$('[data-gallery-thumb]', g).forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
        const src = t.dataset.src;
        const type = t.dataset.type || 'image';
        if (type === 'video') {
          main.innerHTML = `<video src="${src}" autoplay muted loop playsinline></video>`;
        } else {
          main.innerHTML = `<img src="${src}" alt="${t.dataset.alt || ''}" width="1200" height="1200">`;
        }
      });
    });
  });

  /* ---------- Quantity ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const step = b.dataset.qty === 'up' ? 1 : -1;
    input.value = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form: selling plans + price ---------- */
  $$('form.product-form').forEach((form) => {
    const priceEl = $('[data-price]', form.closest('[data-product]') || document);
    const compareEl = $('[data-compare-price]', form.closest('[data-product]') || document);
    const noteEl = $('[data-price-note]', form.closest('[data-product]') || document);
    const options = $$('input[name="purchase_option"]', form);
    const planInput = $('input[name="selling_plan"]', form);
    const update = () => {
      const sel = options.find((o) => o.checked);
      if (!sel) return;
      if (planInput) planInput.value = sel.dataset.plan || '';
      if (priceEl && sel.dataset.price) priceEl.textContent = money(parseInt(sel.dataset.price, 10));
      if (compareEl) {
        if (sel.dataset.compare && sel.dataset.compare !== sel.dataset.price) { compareEl.textContent = money(parseInt(sel.dataset.compare, 10)); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (noteEl) noteEl.textContent = sel.dataset.note || '';
      const scope = form.closest('[data-product]') || document;
      const idInput = $('input[name="id"]', form);
      if (idInput && sel.dataset.variant) idInput.value = sel.dataset.variant;
      const unitEl = $('[data-unit-price]', scope);
      if (unitEl && sel.dataset.unit) unitEl.textContent = sel.dataset.unit;
      const shipEl = $('[data-ship-note]', scope);
      if (shipEl && sel.dataset.ship) shipEl.innerHTML = sel.dataset.ship === 'versandkostenfrei' ? 'versandkostenfrei' : sel.dataset.ship.replace('Versand', '<a href="/pages/versand-zahlung">Versand</a>');
      const bbPrice = $('.buybar__price');
      if (bbPrice && sel.dataset.price) bbPrice.innerHTML = money(parseInt(sel.dataset.price, 10)) + ' <small>· ' + (sel.dataset.note || '') + '</small>';
    };
    options.forEach((o) => o.addEventListener('change', update));
    update();

    /* AJAX add to cart */
    form.addEventListener('submit', async (e) => {
      if (!window.SKIN || !window.SKIN.ajaxCart) return;
      e.preventDefault();
      const btn = $('[type="submit"]', form);
      const label = btn.querySelector('span');
      const orig = label ? label.textContent : '';
      btn.setAttribute('aria-disabled', 'true');
      if (label) label.textContent = window.SKIN.t.adding || '…';
      try {
        const fd = new FormData(form);
        if (planInput && !planInput.value) fd.delete('selling_plan');
        const res = await fetch(window.SKIN.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        if (!res.ok) throw new Error((await res.json()).description || 'Fehler');
        await refreshCart();
        openDrawer('CartDrawer');
      } catch (err) {
        alert(err.message);
      } finally {
        btn.removeAttribute('aria-disabled');
        if (label) label.textContent = orig;
      }
    });
  });

  /* ---------- Cart (drawer + page) ---------- */
  async function refreshCart() {
    const res = await fetch(window.SKIN.routes.cart + '.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    const drawer = $('[data-cart-drawer-lines]');
    if (drawer) {
      if (!cart.items.length) {
        drawer.innerHTML = `<p class="muted" style="padding:24px 0">${window.SKIN.t.empty}</p>`;
      } else {
        drawer.innerHTML = cart.items.map((it) => `
          <div class="mini-line" data-line-key="${it.key}">
            <div class="mini-line__media">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2')}" alt="">` : ''}</div>
            <div>
              <div class="mini-line__title">${it.product_title}</div>
              <div class="mini-line__meta">${it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '')}</div>
              <div class="mini-line__meta" style="margin-top:6px">
                <div class="qty" style="height:36px"><button type="button" data-line-qty="-1" aria-label="−">−</button><input type="number" value="${it.quantity}" min="0" data-line-input><button type="button" data-line-qty="1" aria-label="+">+</button></div>
              </div>
            </div>
            <div class="mini-line__price">${money(it.final_line_price)}</div>
          </div>`).join('');
      }
      $$('[data-cart-subtotal]').forEach((el) => (el.textContent = money(cart.items_subtotal_price)));
      $$('[data-cart-checkout]').forEach((el) => el.toggleAttribute('disabled', !cart.items.length));
    }
  }
  async function changeLine(key, quantity) {
    await fetch(window.SKIN.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if ($('[data-cart-page]')) { window.location.reload(); return; }
    await refreshCart();
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (!b) return;
    const line = b.closest('[data-line-key]');
    const input = $('[data-line-input]', line);
    const q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.lineQty, 10));
    changeLine(line.dataset.lineKey, q);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (!input) return;
    const line = input.closest('[data-line-key]');
    changeLine(line.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('click', (e) => {
    const r = e.target.closest('[data-line-remove]');
    if (!r) return;
    e.preventDefault();
    changeLine(r.closest('[data-line-key]').dataset.lineKey, 0);
  });

  /* ---------- Header shadow on scroll ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }


  /* ---------- FAQ hub: live search + active category ---------- */
  $$('[data-faq-hub]').forEach((hub) => {
    const input = $('[data-faq-search]', hub);
    const groups = $$('[data-faq-group]', hub);
    const empty = $('[data-faq-empty]', hub);
    const norm = (t) => t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (input) input.addEventListener('input', () => {
      const q = norm(input.value.trim());
      let hits = 0;
      groups.forEach((g) => {
        let groupHits = 0;
        $$('[data-faq-item]', g).forEach((it) => {
          const match = !q || norm(it.textContent).includes(q);
          it.hidden = !match;
          if (match) { groupHits++; if (q) it.open = true; } else { it.open = false; }
        });
        g.hidden = groupHits === 0;
        hits += groupHits;
      });
      if (empty) empty.hidden = hits !== 0;
    });
    const links = $$('[data-faq-cat]', hub);
    if ('IntersectionObserver' in window && links.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id));
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach((g) => g.id && io.observe(g));
    }
  });

  /* ---------- Article reading progress ---------- */
  const bar = $('[data-read-progress]');
  const art = $('.article__body');
  if (bar && art) {
    let t = false;
    const upd = () => {
      const r = art.getBoundingClientRect();
      const total = r.height - window.innerHeight * 0.6;
      const p = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.2) / (total || 1)));
      bar.style.transform = `scaleX(${p.toFixed(3)})`;
      t = false;
    };
    window.addEventListener('scroll', () => { if (!t) { requestAnimationFrame(upd); t = true; } }, { passive: true });
    upd();
  }

  /* ---------- v8.6: PDP slideshow (swipe, arrows, thumbnails) ---------- */
  $$('[data-media-gallery]').forEach((g) => {
    const track = $('[data-media-track]', g);
    if (!track) return;
    const slides = Array.from(track.children);
    const idx = $('[data-media-index]', g);
    const thumbs = $$('[data-media-goto]', g);
    const prev = $('[data-media-prev]', g), next = $('[data-media-next]', g);
    let cur = 0, raf = false;
    const go = (i) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    };
    const sync = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === cur && idx && idx.textContent === String(i + 1)) return;
      cur = i;
      if (idx) idx.textContent = String(i + 1);
      thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      slides.forEach((sl, k) => { const v = sl.querySelector('video'); if (v) { if (k === i) { v.play && v.play().catch(() => {}); } else { v.pause && v.pause(); } } });
      const at = thumbs[i]; if (at && at.parentElement) { const p = at.parentElement; const l = at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2; p.scrollTo({ left: l, behavior: 'smooth' }); }
    };
    track.addEventListener('scroll', () => { if (raf) return; raf = true; requestAnimationFrame(() => { sync(); raf = false; }); }, { passive: true });
    prev && prev.addEventListener('click', () => go(cur - 1));
    next && next.addEventListener('click', () => go(cur + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.mediaGoto, 10))));
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    sync();
  });

  /* ---------- v7: dose count-up (German thousands separator) ---------- */
  const fmt = (n) => n.toLocaleString('de-DE');
  $$('[data-count-to]').forEach((el) => {
    const target = parseInt(String(el.dataset.countTo).replace(/\D/g, ''), 10);
    if (!target || reduced || !('IntersectionObserver' in window)) return;
    el.textContent = fmt(0);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now(), dur = 1600;
        const step = (now) => {
          const k = Math.min(1, (now - t0) / dur);
          const eased = 1 - Math.pow(1 - k, 3);
          el.textContent = k < 1 ? fmt(Math.round(target * eased)) : el.dataset.countTo;
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  });

  window.SKIN = window.SKIN || {};
  window.SKIN.refreshCart = refreshCart;
})();
